import {
  ClipThumbnail,
  MaxWidthContainer,
  StyledWrapper,
} from "../../styledComponents";
import { ClipPruned } from "MVVM/Components/Clip/Components/ClipPruned";
import { PrunedViewModel } from "./ViewModel";
import { IClip } from "MVVM/@types";

export const Pruned = ({
  thumbnail,
  clip,
  refetchClip,
}: {
  thumbnail: string;
  clip: IClip;
  refetchClip: () => void;
}) => {
  const { recoverPrunedClip } = PrunedViewModel({
    clipId: clip.internalId,
    refetchClip,
  });

  return (
    <StyledWrapper
      data-testid="pruned-wrapper"
      justifyContent={"center"}
      alignItems={"center"}
    >
      <MaxWidthContainer>
        <ClipThumbnail snapshot={thumbnail} />
        <ClipPruned
          onClick={recoverPrunedClip}
          onDemand={clip?.status === "ON_DEMAND"}
          clipTitle={clip?.title}
          clipId={clip?.internalId}
        />
      </MaxWidthContainer>
    </StyledWrapper>
  );
};
